/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateStorageAccountRequest
 */
export interface UpdateStorageAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateStorageAccountRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorageAccountRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorageAccountRequest
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorageAccountRequest
     */
    servicePrincipalClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorageAccountRequest
     */
    servicePrincipalClientSecret?: string;
}

/**
 * Check if a given object implements the UpdateStorageAccountRequest interface.
 */
export function instanceOfUpdateStorageAccountRequest(value: object): value is UpdateStorageAccountRequest {
    return true;
}

export function UpdateStorageAccountRequestFromJSON(json: any): UpdateStorageAccountRequest {
    return UpdateStorageAccountRequestFromJSONTyped(json, false);
}

export function UpdateStorageAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStorageAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'region': json['region'] == null ? undefined : json['region'],
        'servicePrincipalClientId': json['servicePrincipalClientId'] == null ? undefined : json['servicePrincipalClientId'],
        'servicePrincipalClientSecret': json['servicePrincipalClientSecret'] == null ? undefined : json['servicePrincipalClientSecret'],
    };
}

export function UpdateStorageAccountRequestToJSON(json: any): UpdateStorageAccountRequest {
    return UpdateStorageAccountRequestToJSONTyped(json, false);
}

export function UpdateStorageAccountRequestToJSONTyped(value?: UpdateStorageAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'region': value['region'],
        'servicePrincipalClientId': value['servicePrincipalClientId'],
        'servicePrincipalClientSecret': value['servicePrincipalClientSecret'],
    };
}

